<template>
	<div id='simulat' class="warp_list1">
		<!-- <blacktitle></blacktitle> -->
		<div class='warp_list'>
			<div style="width: 10%;">
				<menulist :menulists='menulists'></menulist>
			</div>
			<div style="width: 90%;" v-show='false'>
				<div style="width: 23%;">
					<tablelist :firstlist='fromdata.firstlist'></tablelist>
				</div>
				<div style="width: 32%;height: 40.6rem;position: relative;">
					<!-- height: 33rem; -->
					<div>
						<a-row>
							<a-col :span='12'>
								<div class='green-font font_warp' style="border-right: 1px solid #fff;">
									買入
								</div>
							</a-col>
							<a-col :span='12'>
								<div class='green-font font_warp'>
									賣出
								</div>
							</a-col>
						</a-row>
					</div>
					<setgetlist :setgetlist='fromdata.setgetlist'></setgetlist>
					<div class='blue-font font_warp'>交易記錄</div>
					<timelist :timelist='fromdata.timelist'></timelist>
					<div class='blue-font font_warp' style="position: relative;">
						<!-- <img :src="require('@/image/simu/backx.png')" alt="" style="position: absolute;
left: 0.2rem;width: 1rem;top: 0.5rem;"> -->
						相關資料
					</div>
					<div v-for='(item,ind) in fromdata.backlist' class='warp-div' :key='ind+"30102"'>
						{{item}}
					</div>
					<div style="position: absolute;bottom: 0;font-size: 1rem;">
						FIN DIV $1.70
						<br>
						REC:COB ON 20/5/21
					</div>
				</div>
				<div style="width: 45%;">
					<div class='blue-font bulu-border font_warp1' style="overflow: hidden;">
						<div style="float: left;">
							<img :src="treeimg1" alt="" style='width: 2.6rem;'>
							<img :src="treeimg2" alt="" style='width: 2.6rem;'>
							<img :src="treeimg3" alt="" style='width: 2.6rem;'>
						</div>
						長和
						<div style="float: right;"><input type="text" v-model="input"
								style="background-color: #338fff;width: 4rem;"></div>
					</div>
					<a-row>
						<a-col :span='12'>
							<div class='blue-font font_warp' style="border-right: 1px solid #fff;">買盤</div>
						</a-col>
						<a-col :span='12'>
							<div class='blue-font font_warp'>賣盤</div>
						</a-col>
						<a-col :span='12'>
							<a-row>
								<a-col :span='6' v-for='(item,indc) in fromdata.leftlist' :key='indc+"07010"'>
									<div v-if='item>0' class='warp-buul font_warp'>{{item}}</div>
									<div v-else class='blue-font font_warp blue-font1'>{{item}}</div>
								</a-col>
							</a-row>
						</a-col>
						<a-col :span='12'>
							<a-row>
								<a-col :span='6' v-for='(item,indk) in fromdata.rightlist' :key='indk+"0709"'>
									<div v-if='item<10' class='blue-font font_warp blue-font1'>{{item}}</div>
									<div v-else class='font_warp'>{{item}}</div>
								</a-col>
							</a-row>
						</a-col>
					</a-row>
					<div class='blue-font font_warp bulu-border font_warp1'>www.aastocks.com</div>
					<a-row>
						<a-col :span='12'>
							<div class='blue-font font_warp font_warptop'>即市圖表</div>
						</a-col>
						<a-col :span='12'>
							<div class='blue-font font_warp'>技術分析資料</div>
						</a-col>
					</a-row>
					<linehcart :dataBol='true' :useData='{id:"lineChart11"}'
						:widthPxMess='{XYSize: 11.6143,legendSize: 11.6143,legendWidth: 108.188,titleSize: 15.91,}'>
					</linehcart>
				</div>

				<div id='border-bule'>
					<div style="width: 70%;display: inline-block;border-right: 1px solid #666;">
						<a-row v-for='(item,inds) in messagelist' :key='inds+"111222"'>
							<a-col :span='1'>
								<div style="margin-left: .1rem;" class='warp_lit'>
									{{item.data}}
								</div>
							</a-col>
							<a-col :span='1' class='warp_lit'>{{item.time}}</a-col>
							<a-col :span='20' class='warp_blue'>{{item.mess}}</a-col>
							<a-col :span='2' v-if='inds==0'><button>更多新聞</button></a-col>
						</a-row>
					</div>
					<div style="width: 30%;display: inline-block;vertical-align: top;">
						<a-row>
							<a-col :span='3'>
								<div style="margin-left: .1rem;" class='warp_lit'>
									{{messagefrom[0].data}}
								</div>
							</a-col>
							<a-col :span='3' class='warp_lit'>{{messagefrom[0].time}}</a-col>
							<a-col :span='18' class='warp_blue'>{{messagefrom[0].mess}}</a-col>
						</a-row>
					</div>
				</div>
			</div>
			<div style="width: 90%;">
				<div style="display: flex;">
					<div style="width: 27%;margin: 0 10px;">
						<div class="maichu_title">
							<div style="background-color: #f6952d;color: #fff;">買入</div>
							<div style="background-color: #1a8b96;color: #fff;">沽出</div>
						</div>
						<div :style="{backgroundColor:'#dceef9'}">
							<!-- :rules='rules' -->
						<a-form-model ref='ruleForm' :model="form" labelAlign='right' layout="horizontal" 
							hideRequiredMark :label-col="labelCol" :wrapper-col="wrapperCol">
							<a-form-model-item label='股票名稱' v-show='false'>
								<span v-if='form.reference'>{{form.reference}}</span>
							</a-form-model-item>
							<a-form-model-item label='市 場' prop='exchange_code' style='padding-top: 30px;'>
								<a-select v-model="form.exchange_code" class='warp_width' @change='handf()'>
									<a-select-option v-for="(item) in Arr1" :key="item.key+'a'" :value="item.value">
										{{item.text }}
									</a-select-option>
								</a-select>
							</a-form-model-item>
							<a-form-model-item label='買/沽' prop='bs_flag' v-show='0'>
								<a-select v-model="form.bs_flag" class='warp_width'>
									<a-select-option v-for="(item) in admintypeArrs" :key="item.key+'a'"
										:value="item.value">{{england=="cn" ?item.text : item.entext}}</a-select-option>
								</a-select>
							</a-form-model-item>
							<a-form-model-item label='類 型' prop='order_type'>
								<a-select v-model="form.order_type" class='warp_width' @change='handz'>
									<a-select-option v-for="(item,index) in admintypeArr"
										v-if="form.exchange_code == 'HKEX'?index>0:index==0" :key="item.key+'a'"
										:value="item.value">{{item.text}}</a-select-option>
								</a-select>
							</a-form-model-item>
							<a-form-model-item label='代 碼' prop='product_code'>
								<a-input v-model="form.product_code" class='warp_width' @input='getdata' />
							</a-form-model-item>
							<a-form-model-item label='價 格' prop='price' >
								<div style='display: flex;justify-content: space-between;align-items: center;'>
								<a-input v-model="form.price" style='width: 16rem;' @input="fannum()" />
								<div class='warp_btn' style="background-color: #3bc7a1;" @click='addnum("price",0)'>—</div>
								<div class='warp_btn' style="background-color: #ffa647;" @click='addnum("price",1)'>+</div></div>
							</a-form-model-item>
							<a-form-model-item label='數 量' prop='qty'>
								<div style='display: flex;justify-content: space-between;align-items: center;'>
								<a-input v-model="form.qty" style='width: 16rem;' @input="qtyFn" />
								<div class='warp_btn' style="background-color: #3bc7a1;" @click='pulnum("qty",0)'>—</div>
								<div class='warp_btn' style="background-color: #ffa647;" @click='pulnum("qty",1)'>+</div></div>
							</a-form-model-item>
						</a-form-model>
						<div style="text-align: center;margin-top: 50px;margin-bottom: 50px;padding: 0 20px;display: flex;justify-content: space-between;">
							<button class='btnfour' @click='fourFn(1)'
								:style='{backgroundColor:fourthqty=="1"?"#ffa647":""}'>全倉</button>
							<button class='btnfour' @click='fourFn(2)'
								:style='{backgroundColor:fourthqty=="2"?"#ffa647":""}'>半倉</button>
							<button class='btnfour' @click='fourFn(3)'
								:style='{backgroundColor:fourthqty=="3"?"#ffa647":""}'>1/3</button>
							<button class='btnfour' @click='fourFn(4)'
								:style='{backgroundColor:fourthqty=="4"?"#ffa647":""}'>1/4</button>
						</div>
						<div style="text-align: center;padding-bottom: 50px;">
							<button class='btn1 btnx' @click='nextfn'>
								下單
							</button>
							<button class='btn1 btn2' @click='resetForm("ruleForm")'>清除</button>
						</div>
						</div>
					</div>
					<div style="width: calc(73% - 30PX);">
						<div class="maichu_title">
							<div style="background-color: #f6952d;color: #fff;width: 18%;">港股</div>
							<div style="background-color: #1a8b96;color: #fff;width: 82%;">美股</div>
						</div>
						<div style="padding: 20px 0 0 0 ;background-color: #fff;">
							<a-form-model ref='ruleForm' :model="form" hideRequiredMark >
							<a-form-model-item>
								<div style="display: flex;">
									<div slot='label' style="padding: 0 10px 0 20px;">股票代碼</div>
										<a-input v-model="form.product_code" class='warp_width' style='width: 10rem;'/> 	
										<button class='btn1 btnx' style="width: 5rem;">
											<a-icon type="search"></a-icon> 查 詢
									</button>
								</div>
							</a-form-model-item>
							</a-form-model>
						</div>
					</div>
				</div>
				<div style="display: flex;margin-top: 10px;">
					<div style="width: 27%;margin: 0 10px;">
						<div class="maichu_title">
							<div style="background-color: #f6952d;color: #fff;">HKD等值</div>
							<div style="background-color: #1a8b96;color: #fff;">現金餘額</div>
						</div>
						<div style="padding: 0 20px;background-color: #fff;">
							<div v-for='(v,i) in hkdarr' :key='i+666' 
							style="display: flex;justify-content: space-between;padding: 14.5px 0;border-bottom: 1px solid #f4f4f4;"
							>
								{{v.a}} <span :style='{color: v.t==1?"#3eb35a":""}'>{{v.n}}</span>
							</div>
							</div>
						</div>
					<div style="width: calc(73% - 30PX);" id='my_table'>
						<table>
							<tr>
								<th style="border-right: 1px solid #fff;" v-for='(val,ind) in aerr' :key='ind + "6325"'>{{val}}</th>
								
								
							</tr><tr style="backgroundColor: #fff">
							<td >message</td><td>message</td></tr>
							<tr style="backgroundColor: #f9f9f9">
								<td>message2</td>
							<td>message2</td></tr>
						</table>
					</div>
				</div>
			</div>
		</div>
		<!-- <div class='btnback'>登出</div> -->
		<handItemEn v-if='land=="eng"'></handItemEn>
		
		<handItem v-else></handItem>
	</div>
</template>

<script>
	import blacktitle from './component/blacktitle'
	import menulist from './component/menulist'
	import tablelist from './component/tablelist'
	import setgetlist from './component/setgetlist'
	import timelist from './component/timelist'
	import linehcart from './component/linehcart'
	import handItem from './handItem.vue'
	import handItemEn from './handItemEn.vue'

	export default {
		components: {
			blacktitle,
			handItem,
			menulist,
			tablelist,
			setgetlist,
			timelist,
			handItemEn,
			linehcart
		},
		data() {
			return {
				aerr:['股票代碼','股票名稱',
				'總股數',
				'參考價',
				'市值（參考價）',
				'盈利（虧損）',
				'貨幣'
				],
				islook:true,
				land:'',
				hkdarr:[
					{a:'可用現金',t:'1' ,n:'1,013,555.73'},
					{a:'交易限制',t:'0' ,n:'0.00'},
					{a:'已用現金',t:'0' ,n:'0.00'},
					{a:'可動用現金',t:'1' ,n:'1,013,5555,.73'},
					{a:'總貨值（前收市價）',t:'0' ,n:'0.00'},
					{a:'組合投資總值（前收市價）',t:'0' ,n:'0.00'},
				],
				fourthqty: '',
				Arr1: [{
					text: '港股',
					gumoney: 'HKD',
					value: 'HKEX',
					gucode: 'HK',
					img: require('@/image/simu/HK.png'),
				}, {
					text: '美股',
					gumoney: 'USD', //自己用
					value: 'US',
					gucode: 'US',
					img: require('@/image/simu/US.png')
				}, {
					text: '澳洲',
					gumoney: 'AUD',
					value: 'AU',
					gucode: 'AU',
					img: require('@/image/simu/AU.png')
				}, {
					text: '日本',
					gumoney: 'JPY',
					value: 'JP',
					gucode: 'JP',
					img: require('@/image/simu/JP.png')
				}, {
					text: '新加坡',
					gumoney: 'SGD',
					value: 'SGX',
					gucode: 'SGX',
					img: require('@/image/simu/SGX.png')
				}],
				admintypeArrs: [{
						text: '買入',
						value: 'B'
					},
					{
						text: '沽出',
						value: 'S'
					}
				],
				admintypeArr: [{
					text: '限價盤',
					entext: 'Mainboard',
					value: 'PL'
				}, {
					text: '增強限價盤',
					entext: 'Mainboard',
					value: 'E'
				}, {
					text: '競價限價盤',
					entext: 'Mainboard',
					value: 'I'
				}],
				labelCol:{
					span:2,
					offset:1
				},
				wrapperCol:{
					span:20
				},
				form: {
					reference: '',
					enable_approval_warning: 'N',
					enable_price_warning: 'Y',
				
					exchange_code: 'HKEX',
					order_type: 'PL',
					client_acc_code: '1000005',
					qty: '', //數量
					price: '',//价钱
					product_code: '',//股票編號
					bs_flag: 'B',
				
					ip_address: '192.168.31.228',
					localized_name: 'Y', //固定
				},
				input: '00001',
				treeimg1: require('@/image/simu/from.png'),
				treeimg2: require('@/image/simu/find.png'),
				treeimg3: require('@/image/simu/table.png'),
				messagefrom: [{
					data: '05-11',
					time: '15:00',
					mess: '[即市新聞] 騰訊控股(00700)出現大手買入1.13萬股。成交價$581.5 涉資657.095萬[AAFN]',
				}],
				messagelist: [{
					data: '05-11',
					time: '15:00',
					mess: '[即市新聞] 東京新增925宗確診[AAFN]',
				}, {
					data: '05-11',
					time: '14:57',
					mess: '[即市新聞] 晶片短缺可能會持續數年[AAFN]',
				}, {
					data: '05-11',
					time: '14:56',
					mess: '[即市新聞] 今日新增1宗輸入新館疫情[AAFN]',
				}, ],
				menulists: [
				// 	{
				// 	name: '證券買賣',
				// 	type: '01',
				// 	static: false,
				// 	child: [{
				// 		name: '港股交易',
				// 		type: '11',
				// 	}, {
				// 		name: '美股交易',
				// 		type: '12',
				// 	}],
				// }, 
				{
					name: '新股認購',
					type: '04',
					static: false,
					child: [{
						name: '公開認購',
						type: '41',
					}, {
						name: '認購記錄',
						type: '42',
					}, ],
				}, {
					name: '投資組合',
					type: '07',
					static: false,
					child: [{
						name: '股票持有',
						type: '71',
					}, {
						name: '現金餘額',
						type: '72',
					}, ],
				}, {
					name: '交易記錄',
					type: '02',
					static: false,
					child: [ {
						name: '當日成交',
						type: '21',
					}, {
						name: '歷史成交',
						type: '23',
					}, {
						name: '歷史價格',
						type: '25',
					},{
						name: '待成交單',
						type: '24',
					},{
						name: '歷史委託',
						type: '22',
					}],
				}, {
					name: '存款提款',
					static: false,
					type: '03',
					child: [{
						name: '提款指示',
						type: '31'
					}, {
						name: '存款通知',
						type: '32'
					}, {
						name: '提存記錄',
						type: '33'
					}],
				}, {
					name: '帳戶管理',
					type: '05',
					static: false,
					child: [{
						name: '更改密碼',
						type: '51',
						// }, {
						// 	name: '衍生產品條款',
						// 	type:'52',
					}],
				}, {
					name: '其他',
					type: '06',
					static: false,
					child: [{
						name: '申請報價',
						type: '61',
					}, {
						name: '示範',
						type: '62',
					}],
				}, ],
				fromdata: {
					firstlist: [{
							name: '最高價',
							num: '65.650'
						},
						{
							name: '最底價',
							num: '65.650'
						},
						{
							name: '開市價',
							num: '65.650'
						},
						{
							name: '前收市價',
							num: '65.650'
						},
						{
							name: '現價',
							num: '65.650'
						},
						{
							name: '升跌($)',
							num: '-1.700',
							color: 'red'
						},
						{
							name: '升跌(%)',
							num: '-2.568%',
							color: 'red'
						},
						{
							name: '成交量',
							num: '4.85百萬'
						},
						{
							name: '成交金額',
							num: '3.13億'
						},
						{
							name: '平均價',
							num: '65.650'
						},
						{
							name: 'IEP/IEV',
							num: '-'
						},
						{
							name: '每手股數',
							num: '500'
						},
						{
							name: '差價',
							num: '0.05/0.05'
						},
						{
							name: '52遇最高',
							num: '65.650'
						},
						{
							name: '52遇最低',
							num: '45.800'
						},
						{
							name: '市盈率',
							num: '8.650'
						},
						{
							name: '收益率',
							num: '3.61%'
						},
						{
							name: '派息',
							num: '2.650'
						},
						{
							name: '每股盈利',
							num: '7.650'
						},
						{
							name: '已發行股本',
							num: '7354.60M'
						},
						{
							name: '市值',
							num: '2469.79億'
						},
						{
							name: '貨幣',
							num: 'HKD'
						},

					],
					setgetlist: ['63.950', '64,050', '21.6%', '78.4%', '5.5K (   6)',
						'20K(  9)', '46.5(  18)', '20.5k(  8)', '36k(  12)', '28.5k(   5)',
						'36.5k(  18)', '28k(  6)', '84.5k(  18)', '26k(  10)'
					],
					timelist: [{
						time: '15:10:24',
						set: '1000',
						bnum: '64.025',
						a: 'A'
					}, {
						time: '15:10:13',
						set: '500',
						bnum: '64.000',
						a: 'U'
					}, {
						time: '15:10:07',
						set: '28.5k',
						bnum: '64.000',
						a: 'B'
					}, {
						time: '15:10:24',
						set: '1000',
						bnum: '64.025',
						a: 'A'
					}, {
						time: '15:10:04',
						set: '500',
						bnum: '64.100',
						a: 'A'
					}, {
						time: '15:09:56',
						set: '500',
						bnum: '64.100',
						a: 'A'
					}, ],
					backlist: ['12661C',
						'17190C',
						'19286C',
						'20563C',
						'23868C',
						'25647P',
						'13231C',
						'17683C',
						'19971C',
						'20968C',
						'24317C',
						'25706C',
						'13431C',
						'18294C',
						'20279C',
						'21540C',
						'25411C',
						'26223C',
						'13567C',
						'18752C',
						'20401C',
						'22783C',
						'25574C',
						'29445P',
						'16877C',
						'18949C',
						'20506C',
						'23295C',
						'25584C',
						'29883C'
					],
					leftlist: ['0460', '1048', '5336', '1799',
						'4378', '1048', '5338', '1799',
						'6728', '8578', '5336', '2029',
						'3440', '8463', '5347', '1450',
						'3439', '9023', '2311', '1048',
						'7190', '7389', '-2', '0317',
						'-1', '9023', '2311', '8176',
						'8302', '2311', '8578', '5346',
						'5368', '6698', '8145', '-3',
						'5515', '1799', '8145', '1450'
					],
					rightlist: [
						'1048', '0517', '8565', '2077',
						'6698', '1450', '1048', '+4',
						'1049', '1450', '4974', '8565',
						'4973', '4975', '2079', '1048',
						'4377', '4975', '+3', '8564',
						'7389', '4974', '1450', '8565',
						'5338', '8564', '1778', '8565',
						'2576', '2576', '8564', '8565',
						'6036', '+2', '1048', '1450',
						'1', '1450', '4974', '2077',
					]
				}
			}
		},
		mounted() {
			
		},
		created(){
			let ar = location.href.split('?land=')
			if(ar.length>1){
				land =  ar[1]
			}
		},
		methods: {

		}
	}
</script>

<style lang="scss">
	#my_table{
		table,th,td{border:1px solid #eeeeee;text-align: center;}
		th{
			background-color: #0C8B96;
			color: #fff;
			width: 10rem;
			padding: 7px 0;
			font-size: .9rem;
			    font-weight: 100;
		}
		td{
			
			padding: 8px 0;
		}
		table{border-collapse:collapse;}
	}
	.warp_lit {
		color: #666;
		font-size: .8rem;
	}

	.warp_blue {
		color: #3177bd;
		font-size: .8rem;
	}

	#border-bule {
		border: 1px solid #c5e3ff;
		display: block;
		height: 4rem;
		overflow: hidden;
	}

	// .btnback {
	// 	position: fixed;
	// 	bottom: .2rem;
	// 	left: .1rem;
	// 	width: 10%;
	// 	background-color: #25bcca;
	// 	color: #fff;
	// 	height: 1.8rem;
	// 	line-height: 1.8rem;
	// 	text-align: center;
	// }

	.warp_list>div {
		display: inline-block;
		vertical-align: top;
	}

	// .warp_list>div>div {
	// 	display: inline-block;
	// 	vertical-align: top;
	// }

	.warp_list1 {
		// height: 100vh;
		height: '(100vh - 3rem)';
		// background-color: #e3effb;
	}

	.green-font {
		background-color: #0c8b97;
		color: #fff;
		text-align: center;
		font-size: .8rem;
	}

	.blue-font {
		background-color: #0c8b97; //3177bd
		color: #fff;
		text-align: center;
	}

	.blue-font1 {
		background-color: #3177bd;
	}

	.warp-div {
		display: inline-block;
		width: 20%;
		font-size: 1rem;
	}

	.bulu-border {
		border-bottom: 1px solid #5994d0;
		font-size: 1rem;
	}

	.warp-buul {
		background-color: #bfd9f2;
	}

	.font_warp {
		text-align: center;
		padding: .2rem 0;
		font-size: 1rem;
	}

	.font_warp:before {
		
	}

	.font_warptop:after {
		content: '';
		width: 0;
		height: 0;
		position: absolute;
		border: 10px solid;
		border-color: transparent transparent #fff transparent;
		left: 9.6rem;
		top: .8rem;
		// border-bottom: 0;
	}

	.font_warp1 {
		font-size: 1.2rem;
	}
	#simulat {
		.ant-form-item-label > label::after{
			content: '';
		}
		.ant-form-item-label > label{
			
		}
		.mark-file div {
				margin: 0 !important;
				padding: 0.7rem 1rem;
		}
		.ant-modal {
			top: 15vh;
		}
	
		.warp_min {
			vertical-align: top;
			width: 70%;
			height: 3rem;
			line-height: 3rem;
			font-size: 1rem;
			padding: .7rem 0;
			display: inline-block;
		}
	
		.warp_titlis {
			margin-right: .1rem;
			color: #000;
			width: 26.5%;
		}
	
	
		.warp-right {
			text-align: right;
		}
	
		.ant-modal-close-x {
			.anticon svg {
				color: #5cb1b9;
				position: relative;
				top: .8rem
			}
		}
	
		.ant-modal-content {
			border-radius: 10px;
		}
	
		.ant-form-item {
			margin-bottom: 20px;
		}
	
		.ant-form-item label {
			font-size: .8rem !important;
		}
	
		.ant-input {
			font-size: .8rem !important;
		}
	
		.ant-select-selection-selected-value {
			font-size: .8rem !important;
		}
	
		.ant-form-item-children {
			font-size: .8rem !important;
		}
	
		.warp_btn {
			cursor: pointer;
			width: 1.5rem;
			color: #fff;
			display: inline-block;
			margin: 0 .1rem;
			height: 1.5rem;
			line-height: 1.5rem;
			text-align: center;
			border-radius: 10px;
		}
	
		.ant-modal-body {
			padding: 0;
			padding-top: 2.5rem;
		}
	
		.btn1 {
			cursor: pointer;
			width: 6.3rem;
			height: 2rem;
			font-size: .8rem;
			color: #fff;
			border: 0;
			border-radius: 5px;
			margin: 0 1.5rem;
		}
	
		.btnfour {
			cursor: pointer;
			width: 3.6rem;
			// height: 1.5rem;
			padding: .3rem 0;
			font-size: .8rem;
			color: #fff;
			border: 0;
			border-radius: 20px;
			// margin-left: 0.8rem;
			background-color: #0c8b97;
		}
	
		.btnx {
			background-color: #0c8b97;
		}
	
		.btn2 {
			background-color: #999999;
		}
	
		.pos_ste {
			position: relative;
			// width: 2rem;
			font-size: .6rem;
			background-color: #ee7171;
			top: -3rem;
			left: 1rem;
		}
		.maichu_title{
			display: flex;
			justify-content: space-between;
			div{
				width: 50%;
				text-align: center;
				padding: 8px 0;
			}
		}
	}
</style>
